// @flow strict

import type { ContainerDimensions, Source } from '../types';
import type { ResponsiveImageProps } from '../ResponsiveImage';

/**
 * Type for the css property backgroundSize
 * Yes the string makes the 'contain' | 'cover' types obsolete, but still defining them for clarity:
 * contain - fit the complete image in the layout
 * cover - cover the entire layout with the image (default)
 * string -
 */
export type BackgroundSize = 'contain' | 'cover' | string;

type Options = {|
  containerDimensions: ContainerDimensions | null,
  backgroundSizeCalculator: $PropertyType<ResponsiveImageProps, 'backgroundSizeCalculator'>,
  source: null | Source,
  fitStrategy: $PropertyType<ResponsiveImageProps, 'fitStrategy'>,
|};

/** Returns a valid css background-size value */
const getBackgroundSize = ({
  containerDimensions,
  backgroundSizeCalculator,
  fitStrategy,
  source,
}: Options): BackgroundSize => {
  if (fitStrategy === 'contain' || fitStrategy === 'cover') {
    return fitStrategy;
  } else if (fitStrategy === 'calculated') {
    if (backgroundSizeCalculator && source && containerDimensions) {
      return backgroundSizeCalculator(
        source.width,
        source.height,
        containerDimensions.clientWidth,
        containerDimensions.clientHeight,
      );
    }
  }
  return 'cover';
};

export default getBackgroundSize;
